import axiosService from '../../../services/axiosRequestBuilder';
import * as types from '../types';
import LogoutButton from './logout';

const initialState = {
  name: '',
  profile: '',
  expiresAt: '',
  accessToken: '',
  refreshToken: '',
  profileId: 0,
  email: '',
  isLoggedIn: false,
  logando: false,
  isLoading: false,
};

export default function rootReducer(state = initialState, action) {
  const axios = axiosService.getInstance();

  switch (action.type) {
    case types.LOGIN_SUCCESS: {
      // console.log('✅ Reducer LOGIN_SUCCESS recebido:', action.payload);
      const newState = { ...state };

      newState.name = action.payload.name;
      newState.profile = action.payload.profile;
      newState.expiresAt = action.payload.expiresAt;
      newState.accessToken = action.payload.accessToken;
      newState.refreshToken = action.payload.refreshToken;
      newState.profileId = action.payload.profileId;
      newState.email = action.payload.email;
      newState.isLoggedIn = true;
      newState.logando = false;

      localStorage.setItem('name', newState.name);
      localStorage.setItem('profile', newState.profile);
      localStorage.setItem('expiresAt', newState.expiresAt);
      localStorage.setItem('accessToken', newState.accessToken);
      localStorage.setItem('refreshToken', newState.refreshToken);
      localStorage.setItem('profileId', newState.profileId);
      localStorage.setItem('email', newState.email);
      localStorage.setItem('isLoggedIn', newState.isLoggedIn);

      return newState;
    }

    case types.LOGIN_FAILURE: {
      delete axios.defaults.headers.Authorization;
      localStorage.removeItem('name');
      localStorage.removeItem('profile');
      localStorage.removeItem('expiresAt');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('profileId');
      localStorage.removeItem('email');
      localStorage.removeItem('isLoggedIn');

      localStorage.clear();
      const newState = { ...initialState };
      LogoutButton();
      return newState;
    }

    case types.LOGIN_REQUEST: {
      const newState = { ...state };
      newState.logando = true;
      return newState;
    }

    case types.LOGOUT:
      return { ...initialState };

    default: {
      return state;
    }
  }
}
